import { render } from "./coupons-modal.vue?vue&type=template&id=aa800138"
import script from "./coupons-modal.vue?vue&type=script&lang=js"
export * from "./coupons-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__